export type DrillLike = { name?: unknown; description?: unknown };

function lower(v: unknown): string {
  return String(v ?? '').toLowerCase();
}

export function isWarmupSegment(drill: DrillLike | null | undefined): boolean {
  const name = lower(drill?.name);
  return name.includes('warmup') || name.includes('warm-up') || name.includes('dynamic warm');
}

export function isWaterBreakSegment(drill: DrillLike | null | undefined): boolean {
  const name = lower(drill?.name);
  const desc = lower(drill?.description);
  return (
    name.includes('water break') ||
    name.includes('hydration break') ||
    name.includes('hydration') ||
    (name.includes('break') && (name.includes('water') || name.includes('hydrate') || name.includes('rest'))) ||
    desc.includes('hydration') ||
    desc.includes('water break')
  );
}

export function isCooldownSegment(drill: DrillLike | null | undefined): boolean {
  const name = lower(drill?.name);
  const desc = lower(drill?.description);
  return name.includes('cool down') || name.includes('cooldown') || desc.includes('cool down') || desc.includes('cooldown');
}

export function isDebriefSegment(drill: DrillLike | null | undefined): boolean {
  const name = lower(drill?.name);
  const desc = lower(drill?.description);
  return name.includes('debrief') || desc.includes('debrief');
}

